import { render, staticRenderFns } from "./RephonicStats.vue?vue&type=template&id=2c204ab3"
import script from "./RephonicStats.vue?vue&type=script&lang=js"
export * from "./RephonicStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports